export interface CompanyInfo {
  name: string;
  acronym: string;
  sector: string;
}

export interface DomainSuggestion {
  domain: string;
  available: boolean | null; // null = checking
}

export interface ContactInfo {
  fullName: string;
  email: string;
  phone: string;
  country: string;
}

export type EmailPrefix = 'contact' | 'direction' | 'commercial' | 'support' | 'info' | 'admin' | 'rh' | 'facturation';

export type DomainExtension = '.com' | '.net' | '.org' | '.io' | '.co' | '.pro' | '.africa' | '.biz' | '.info' | '.tech' | '.bj';

export const DOMAIN_EXTENSIONS: { value: DomainExtension; label: string; popular?: boolean }[] = [
  { value: '.com', label: '.com', popular: true },
  { value: '.net', label: '.net', popular: true },
  { value: '.org', label: '.org', popular: true },
  { value: '.io', label: '.io' },
  { value: '.co', label: '.co' },
  { value: '.pro', label: '.pro' },
  { value: '.africa', label: '.africa' },
  { value: '.biz', label: '.biz' },
  { value: '.info', label: '.info' },
  { value: '.tech', label: '.tech' },
  { value: '.bj', label: '.bj' },
];

export const DEFAULT_EXTENSIONS: DomainExtension[] = ['.com', '.net', '.org'];

export interface SimulatorState {
  step: number;
  company: CompanyInfo;
  selectedExtensions: DomainExtension[];
  domains: DomainSuggestion[];
  selectedDomain: string;
  selectedEmails: string[];
  contact: ContactInfo;
  paymentChoice: 'pay' | 'callback' | null;
  paymentStatus: 'pending' | 'success' | 'failed' | null;
}

export const EMAIL_PREFIXES: { value: EmailPrefix; label: string; description: string }[] = [
  { value: 'contact', label: 'contact@', description: 'Adresse principale de contact' },
  { value: 'direction', label: 'direction@', description: 'Direction générale' },
  { value: 'commercial', label: 'commercial@', description: 'Service commercial' },
  { value: 'support', label: 'support@', description: 'Support technique / client' },
  { value: 'info', label: 'info@', description: 'Informations générales' },
  { value: 'admin', label: 'admin@', description: 'Administration' },
  { value: 'rh', label: 'rh@', description: 'Ressources humaines' },
  { value: 'facturation', label: 'facturation@', description: 'Service facturation' },
];